(ns frontend.view.kpi-reporting.kpi-categories.settings-events
  (:require
   [common.localization :as loc]
   [frontend.utils :as fu]
   [frontend.conn :as conn]
   [promesa.core :as p]
   [reagent.core :as r]
   [potpuri.core :refer [fn-> fn->>] :as potpuri]
   [common.kpis :as kpis]
   [common.util :as cu]
   [frontend.state.current-session :as session]
   [frontend.view.modals.curtains.settings-curtain.view :as settings-curtain]
   [frontend.view.modals.events :as modals]
   [clojure.string :as string]
   [frontend.logging :as logging]
   [common.schema.registry :as registry]))

(defn reset-state!
  [state]
  (reset! state {:role :role/user}))

(defn set-alert!
  [state text]
  (swap! state assoc :alert text))

(defn hide-alert!
  [state]
  (swap! state dissoc :alert))

;;TODO: multiple attribute backend update:
(defn save-category-settings!
  [state category close!]
  (let [{:keys [kpi-cycle/name
                kpi-cycle/target-month kpi-cycle/target-year]}
        (:edit @state)
        msg {}
        #_{:category-id (:db/id category)
           :kpi-cycle   {:name         name
                         :target-month target-month
                         :target-year  target-year}}]
    (-> (conn/sendp! :kpi-category/update
                     msg)
        (p/then (fn [_]
                  (close!)))
        (p/catch (fn [e]
                   #_(->> e
                          ex-data
                          :message
                          loc/tr
                          (set-alert! state))
                   (logging/error "update-kpi-category! " e))))))

(defn toggle-kpi!
  [category kw enable?]
  (let [op (if enable?
             :kpi-category/add-kpi
             :kpi-category/remove-kpi)]
    (-> (conn/sendp! op
                     {:kpi-category-id (:db/id category)
                      :kpi/kw kw})
        (p/catch (fn [e]
                   #_(->> e
                          ex-data
                          :message
                          loc/tr
                          (set-alert! :kpi))                ;;TODO alerts
                   (logging/error "Unable to toggle kpi" e))))))

(def curtain-opts
  {:quantitative {:all        fu/all-kpis
                  :entity-key :kpi-category/kpis}
   :qualitative  {:all        fu/all-kpi-questions
                  :entity-key :kpi-category/questions}})

(defn open-kpi-curtain!
  [type category]
  (let [tenant-schema @session/tenant-schema
        {:keys [all entity-key]} (get curtain-opts type)]
    (modals/open-modal!
     settings-curtain/modal-key
     {:header-text   (loc/tr :select-kpis)
      :boolean-mode? true
      :options       {true  [:span.label-sm (loc/tr :in-use)]
                      false [:span.label-sm (loc/tr :not-used)]}
      :state         session/session
      :fields-getter (fn [state]
                       (->> (all)
                            (map (fn [{:keys [kw type visible? skip-sort?]}]
                                   {:field/name  (let [fs (registry/get-field-schema
                                                           tenant-schema
                                                           kw)]
                                                   (loc/field-name kw fs))
                                    :field/value (-> state
                                                     :entities
                                                     (get (:db/id category))
                                                     (get entity-key)
                                                     set
                                                     (contains? kw))
                                    :field/key   kw
                                    :skip-sort?  skip-sort?}))
                            (sort (fn [a b]
                                    (let [a-not-sorted? (:skip-sort? a)
                                          b-not-sorted? (:skip-sort? b)]
                                      (cond (and a-not-sorted? b-not-sorted?) 0
                                            a-not-sorted? 1
                                            b-not-sorted? -1
                                            :else
                                            (compare (:field/name a) (:field/name b))))))
                            vec))
      :on-change!    (fn [k v]
                       (toggle-kpi! category k v))})))

(defn blank->nil
  [val]
  (when-not (string/blank? val)
    val))

(defn update-category!
  [state category k v]
  (let [id (:db/id category)
        old-val (-> category
                    k)]
    (if (or (nil? v) (= (blank->nil v) old-val))
      (swap! state potpuri/dissoc-in [:edit-category id k]) ;;prevent unnecessary saving
      (swap! state assoc-in [:edit-category id k] v))))

(defn save-category!
  [category k v on-success! on-error!]
  (let [id (:db/id category)]
    (-> (conn/sendp! :kpi-category/update
                     {:db/id id
                      k      v})
        (p/then (fn [_]
                  (when (fn? on-success!)
                    (on-success!))
                  #_(end-edit! template-id)))
        (p/catch (fn [e]
                   #_(->> e
                          ex-data
                          :message
                          loc/tr
                          (set-alert! :template))
                   (when (fn? on-error!)
                     (on-error!))
                   (logging/error "Unable to edit kpi-category" e))))))

(defn end-guidance-edit!
  [state category kw]
  (swap! state update-in [:guidances (:db/id category)] dissoc kw))

(defn update-guidance!
  [state category kw text]
  (swap! state update-in [:guidances (:db/id category)] assoc kw text))

(defn save-guidance!
  [state category kw]
  (let [guidance (-> @state
                     :guidances
                     (get (:db/id category))
                     kw)]
    (-> (conn/sendp! :kpi-category/update-user-guidance
                     {:category-id (:db/id category)
                      :kw          kw
                      :guidance    guidance})
        (p/then (fn [_]
                  (end-guidance-edit! state category kw)))
        (p/catch (fn [e]
                   #_(->> e
                          ex-data
                          :message
                          loc/tr
                          (set-alert! (if (= (namespace kw) "kpi-q-kw")
                                        :questions
                                        :kpis)))
                   (logging/error "Unable to save use guidance" e))))))

(defn new-separator-kw
  [type ordering]
  (let [separator-nums (->> ordering
                            (filter cu/separator-kw?)
                            (map (fn-> name (subs 1) js/parseInt)))
        sep (if (= type :qualitative)
              "q"
              "k")
        next-num (inc (apply max 0 separator-nums))]
    (keyword "separator" (str sep next-num))))

(defn add-group-heading!
  [state type category ordering]
  (let [ordering-state (r/cursor state [:ordering])
        timer (r/cursor state [:timer])
        new-el (new-separator-kw type ordering)
        new-ordering (vec (concat ordering [new-el]))]
    (swap! ordering-state assoc type new-ordering)
    (-> (conn/sendp! :kpi-category/reorder
                     {:category-id (:db/id category)
                      :type        type
                      :ordering    new-ordering})
        (p/then (fn [_]
                  ;;set a timer that empties local state
                  ;; (so that subscription updates are reflected in frontend)
                  (let [old-timer @timer]
                    (when old-timer
                      (js/clearTimeout old-timer))
                    (reset! timer
                      (js/setTimeout (fn [_]
                                       (swap! ordering-state dissoc type)
                                       (reset! timer nil))
                                     2000)))))
        (p/catch (fn [e]
                   (swap! ordering-state dissoc type)
                   (logging/error "Failed to add kpi-category group heading" e))))))

(defn remove-group-heading!
  [state type category kw]
  (let [ordering-state (r/cursor state [:ordering])
        timer (r/cursor state [:timer])
        ordering (or (get @ordering-state type)
                     (-> category
                         :kpi-category/ordering
                         type))
        new-ordering (->> ordering
                          (remove #{kw})
                          vec)]
    (swap! ordering-state assoc type new-ordering)
    (-> (conn/sendp! :kpi-category/reorder
                     {:category-id (:db/id category)
                      :type        type
                      :ordering    new-ordering})
        (p/then (fn [_]
                  ;;remove group heading title from user-guidances
                  (conn/sendp! :kpi-category/update-user-guidance
                               {:category-id (:db/id category)
                                :kw          kw
                                :guidance    ""})

                  ;;set a timer that empties local state
                  ;; (so that subscription updates are reflected in frontend)
                  (let [old-timer @timer]
                    (when old-timer
                      (js/clearTimeout old-timer))
                    (reset! timer
                      (js/setTimeout (fn [_]
                                       (swap! ordering-state dissoc type)
                                       (reset! timer nil))
                                     2000)))))
        (p/catch (fn [e]
                   (swap! ordering-state dissoc type)
                   (logging/error "Failed to remove kpi-category group heading" e))))))

;;array 'ordering', element of index 'old' being dragged to index 'new'
(defn reorder!
  [state type category ordering old new]
  (let [ordering-state (r/cursor state [:ordering])
        timer (r/cursor state [:timer])
        old-v (nth ordering old)
        new-a (if (<= old new)
                (concat (subvec ordering 0 old)
                        (subvec ordering (inc old) (inc new))
                        [old-v]
                        (nthrest ordering (inc new)))
                (concat (subvec ordering 0 new)
                        [old-v]
                        (subvec ordering new old)
                        (nthrest ordering (inc old))))]
    ;; save new ordering to local state to hide backend delay
    (swap! ordering-state assoc type new-a)
    (when-not (= old new)
      (-> (conn/sendp! :kpi-category/reorder
                       {:category-id (:db/id category)
                        :type        type
                        :ordering    new-a})
          (p/then (fn [_]
                    ;;set a timer that empties local state
                    ;; (so that subscription updates are reflected in frontend)
                    (let [old-timer @timer]
                      (when old-timer
                        (js/clearTimeout old-timer))
                      (reset! timer
                        (js/setTimeout (fn [_]
                                         (swap! ordering-state dissoc type)
                                         (reset! timer nil))
                                       2000)))))
          (p/catch (fn [e]
                     (swap! ordering-state dissoc type)
                     (logging/error "Unable to save kpi-category ordering" e)))))))
